import { Injectable } from '@angular/core';
import { AppConfigService } from "../common/service/mpvAppConfigService";
import { HttpApiService } from "../common/service/mpvHttpApiService";
import { SigedCommonService } from "../siged-common.service";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AuthService } from './auth.service';
import { from, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ParametroService {

    private defaultHeaders;
    getListArea: any;

    constructor(
        public httpApiService: HttpApiService,
        public appConfigService: AppConfigService,
        public mpvCommonService: SigedCommonService,
        private http: HttpClient,
        private authService: AuthService,
    ) {
        this.defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
    }
    baseUrl = this.mpvCommonService.APPLICATION_API_HOST + "/parametro/";

    generalSearchBy(
        url: string,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}${url}`, options).toPromise();
    }
    tipoMensajeriaList(
        params?: HttpParams | { [param: string]: string | string[]; },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}tipo_mensajeria`, options).toPromise();
    }

    //-------------------------------LISTADO PARAMETRO-------------------------------------------------------//
    listarParametro(
        params: HttpParams | { size?: string, page?: string },
        body: { tipo?: string, valor?: string, descripcion?: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}listar`, body, options).toPromise();
    }

    tipoEnvioList(
        params?: HttpParams | { [param: string]: string | string[]; },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}tipo_envio`, options).toPromise();
    }


    temporizadorFirma(
        params?: HttpParams | { [param: string]: string | string[]; },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}temporizador_firma`, options).toPromise();
    }

    motivoFirma(
        params?: HttpParams | { [param: string]: string | string[]; },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}motivo_firma`, options).toPromise();
    }

    detalleParametro(
        params: { idParametro: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}abrir`, options).toPromise();
    }

    actualizar(
        body: {
            "id": number,
            "tipo": string,
            "valor": string,
            "descripcion": string,

        },
        headers?
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}actualizar`, body, options).toPromise();
    }

    getDetalle(
        params: { idParametro: string },
        headers?
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}abrir`, options).toPromise();
    }


    CrearParametro(
        body: {
            "tipo": string,
            "valor": string,
            "descripcion": string,

        },
        headers?
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}crear`, body, options).toPromise();
    }


    EliminarParametro(
        params: { idParametro: string },
        headers?
    ) {

        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}eliminar`, options).toPromise();
    }

    getConsultaMantenimiento(): Observable<any> {
        
        const options = { headers:  this.authService.getDefualtHeaders() }
        const url = `${this.baseUrl}flag_mantenimiento`;

        // Utiliza el operador 'from' para convertir la promesa en un observable
        return from(this.http.get(url, options));
      }
}
